/** 404 pentru un proiect pe care contul ăsta nu are voie să-l vadă.
 *
 *  Serverul răspunde deja corect: cine nu e în organizația proiectului primește
 *  404, nedeosebit de un id inventat (`projects.fetch`). Interfața desena însă
 *  mai departe carcasa — bara de discipline, pașii dosarului, șina din stânga —
 *  iar din ea se citea că proiectul există și cum arată, adică exact ce ținea
 *  ascuns refuzul de la server.
 *
 *  DE CE NU SCRIE NIMIC ALTCEVA. Ecranul ăsta a spus la început «linkul nu duce
 *  nicăieri — fie adresa e greșită, fie proiectul a fost șters». Sunt două
 *  explicații, și în cazul cel mai frecvent amândouă sunt FALSE: proiectul
 *  există, e întreg, doar că omul nu e pe el. O explicație inventată e mai rea
 *  decât niciuna — trimite pe cineva să caute o adresă greșită sau să întrebe
 *  cine a șters un proiect care n-a fost șters.
 *
 *  Iar motivul adevărat nu se poate scrie aici, fiindcă a-l scrie ar însemna să
 *  confirmi că proiectul există — răspunsul pe care 404-ul îl refuză. Deci
 *  ecranul spune atât cât spune și codul de răspuns: nu s-a găsit.
 *
 *  Perechea lui e `FaraAcces`, care are voie să spună tot — dar numai colegului
 *  din ACEEAȘI organizație, care deja are dreptul să știe.
 */
import { Link } from "react-router-dom";
import { useT } from "../i18n";

export default function ProiectInexistent() {
  const t = useT();
  return (
    <div className="fara-acces">
      <div className="card fara-acces-cutie">
        <h1>404</h1>
        <p className="note">{t("inexistent.negasit")}</p>
        {/* Legătura rămâne: nu spune nimic despre proiect, iar fără ea omul
            rămâne pe o pagină moartă, fără nicio ieșire. */}
        <p className="note" style={{ marginTop: 14 }}>
          <Link to="/projects">{t("comun.inapoi_la_proiecte")}</Link>
        </p>
      </div>
    </div>
  );
}
